import { render, staticRenderFns } from "./CompanySettingsIntegrations.vue?vue&type=template&id=1a51dc27&scoped=true"
import script from "./CompanySettingsIntegrations.vue?vue&type=script&lang=js"
export * from "./CompanySettingsIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a51dc27",
  null
  
)

export default component.exports